import {Territory} from '../core/classes/territory';
import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {Store} from '@ngrx/store';
import {selectCounties} from '../state/location/location.reducer';
import {forkJoin, withLatestFrom} from 'rxjs';
import {County} from '../core/classes/county';
import {EmpowerData} from '../shared/classes/empowerData';

@Injectable({
  providedIn: 'root',
})
export class EmpowerService {

  private apiUrl = 'https://services2.arcgis.com/ZQ4jTQn6k7VPXEwO/arcgis/rest/services/HHS_emPOWER_REST_Service_Public/FeatureServer/2';

  private http = inject(HttpClient);
  private store = inject(Store);

  private buildUrl() {
    const urlOptions: Record<string, string | number | boolean> = {
      where: '1=1',
      outFields: '*',
      returnGeometry: false,
      returnExceededLimitFeatures: true,
      orderByFields: 'OBJECTID',
      f: 'geojson',
    };

    const query = Object.keys(urlOptions)
      .map((key) => `${key}=${urlOptions[key]}`)
      .join('&');

    return `${this.apiUrl}/query?${query}`;
  }

  getEmpowerData(territories: Territory[]) {
    const url = this.buildUrl();
    const offsetUrl = url + '&resultOffset=2000';

    return forkJoin([this.http.get<{features: {properties: Partial<EmpowerData>}[]}>(url), this.http.get<{features: {properties: Partial<EmpowerData>}[]}>(offsetUrl)]).pipe(
      map(response => {
        return response[0].features.concat(response[1].features)
          .map((feature) => new EmpowerData(feature.properties));
      }),
      withLatestFrom(this.store.select(selectCounties)),
      map((value: [EmpowerData[], County[]]) => {
        const territoryIds = territories.map(t => t.id);
        const counties = value[1].filter(c => territoryIds.includes(c.stateId));

        const features = counties.map(county => {
          const empowerProperties = value[0].find(f => county.geoid === f.fipsCode) || {};

          return {
            type: 'Feature',
            geometry: JSON.parse(county.boundary),
            properties: empowerProperties,
          };
        });

        return {
          features: features,
        };

      }));
  }
}
